import { useTextes } from '@common/config';
import { TypeDeclaration } from '@common/services';
import React, { useEffect, useState } from 'react';
import { ConfirmationModal, DsfrModal } from '../..';

export const TypeDeclarationChangeConfirmationModal = ({
                                                         dsfrModal,
                                                         onConfirm,
                                                         onCancel,
                                                         typeDeclarationTarget,
                                                       }: DeclarationConsolideeChangeConfirmationModalProps) => {
  const t = useTextes('Commun', 'TypeDeclarationModal');

  const [description, setDescription] = useState<string>('');

  useEffect(() => {
    if (!typeDeclarationTarget) return setDescription('');

    setDescription((typeDeclarationTarget === TypeDeclaration.CONSOLIDEE)
      ? t['DECLARATION_CONSOLIDEE_CONFIRM']
      : t['DECLARATION_INDIVIDUELLE_CONFIRM']);
  }, [typeDeclarationTarget]);

  return <ConfirmationModal dsfrModal={dsfrModal}
                            confirmProps={{ onClick: onConfirm, label: 'VALIDER' }}
                            cancelProps={{ onClick: onCancel, label: 'ANNULER' }}
                            description={description}
                            subDescription={t['DECLARATION_CONFIRM_SUB']} />;
};

export interface DeclarationConsolideeChangeConfirmationModalProps {
  dsfrModal: DsfrModal;
  onConfirm: () => void;
  onCancel: () => void;
  typeDeclarationTarget: TypeDeclaration | null;
}